import { ReactElement } from 'react';

import { DocplannerServiceMappingCreateCommand } from '@dreryk/egabinet-docplanner-frontend-api';

import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import {
   dispatchSnackbarNegativeEvent,
   dispatchSnackbarPositiveEvent,
   ModalConfirmButton,
} from '@dreryk/react-components';

import { medicalServicesMappingsTranslationKeys } from '../../../translations';

import {
   DocplannerServiceMappingCreateFormBean,
   DocplannerServiceMappingCreateFormController,
} from './docplannerServiceMappingCreate.types';

type DocplannerServiceMappingCreateButtonProps = {
   readonly handleSubmit: DocplannerServiceMappingCreateFormController['handleSubmit'];
   readonly onSuccess: VoidFunction;
};

const useDocplannerServiceMappingCreateCommand = (
   onSuccess: VoidFunction
): UseCqrsCommandResult<void, DocplannerServiceMappingCreateFormBean> => {
   return useCqrsCommand(
      (parameters) => {
         const command = new DocplannerServiceMappingCreateCommand();
         command.docplannerServiceId = parameters.docplannerService!.id;
         command.receptionServiceId = parameters.receptionService!.id.asNumber();
         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(medicalServicesMappingsTranslationKeys.mappingCreated);
            onSuccess();
         },
         onFault: {
            'egabinet-docplanner-frontend-api:DocplannerServiceAlreadyMappedFault': () => {
               dispatchSnackbarNegativeEvent(medicalServicesMappingsTranslationKeys.serviceAlreadyMapped);
            },
         },
      }
   );
};

export const DocplannerServiceMappingCreateButton = (
   props: DocplannerServiceMappingCreateButtonProps
): ReactElement => {
   const { executeAsync: createDocplannerServiceMapping } = useDocplannerServiceMappingCreateCommand(props.onSuccess);

   return (
      <ModalConfirmButton
         label={medicalServicesMappingsTranslationKeys.map}
         onClick={props.handleSubmit(createDocplannerServiceMapping)}
      />
   );
};
